import { render, staticRenderFns } from "./orderInfoDetail.vue?vue&type=template&id=00601bca&scoped=true"
import script from "./orderInfoDetail.vue?vue&type=script&lang=js"
export * from "./orderInfoDetail.vue?vue&type=script&lang=js"
import style0 from "./orderInfoDetail.vue?vue&type=style&index=0&id=00601bca&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00601bca",
  null
  
)

export default component.exports